import differenceInMilliseconds from "date-fns/differenceInMilliseconds";
import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";

export const informationOfTheDay = (day)=>{
    const from = startOfDay(day);
    const to = endOfDay(day);
    const totalMilliseconds = differenceInMilliseconds(to, from);
    return {
        from,
        to,
        totalMilliseconds
    }
}